{"domain":"auth.inglisdigital.com","clientId":"AZKiOTrYMOFeCx8QHTCPjMzQ3GMiAJNj","audience":"https://api.vendor.inglis.com.au"}